import { Package } from "@app/types";
import HttpService from "@core/services/http/http.service";

/**
 * cloudPc: true = chỉ gói Cloud PC (tab Cloud PC), false = chỉ gói máy vật lý (tab Máy vật lý),
 * không truyền = cả hai như cũ (trang chủ, popup cũ). API chỉ tính trạng thái của loại được hỏi.
 */
const typeParams = (cloudPc?: boolean) => (cloudPc === undefined ? undefined : { cloud_pc: cloudPc ? 1 : 0 });

class _PackageService {
  public getPackages(categoryId: string, cloudPc?: boolean) {
    return HttpService.get<Package[]>(`/packages/categories/${categoryId}`, {
      queryParams: typeParams(cloudPc),
    });
  }

  public getAllPackages(cloudPc?: boolean) {
    return HttpService.get<Package[]>("/packages", {
      queryParams: typeParams(cloudPc),
    });
  }

  /** Trạng thái Sẵn sàng / Hết máy (chạy nền mỗi 5s, không hiện toast lỗi) */
  public getAvailability(cloudPc?: boolean) {
    return HttpService.get<Pick<Package, "_id" | "is_available" | "available_groups" | "orders_end_time">[]>(
      "/packages/availability",
      {
        silent: true,
        queryParams: typeParams(cloudPc),
      }
    );
  }
}

const PackageService = new _PackageService();

export default PackageService;
